import React, { useContext } from 'react';
import { Link, useStaticQuery, graphql } from 'gatsby';

import { StayInTouch } from '../StayInTouch';
import { queryHelper, nodeHelper, domHelper } from 'helpers';
import { UserContext } from 'contexts';

import { ContentWrapper, MenuList, CloseButton } from './styles';

import CloseIcon from '/static/icons/controls/close.svg';

export const SideMenu = ({ onClose }) => {
  const { user } = useContext(UserContext); // Context API to get user state
  const { navside } = useStaticQuery(graphql`
    query MySideMenuQuery {
      navside: allMenuLinkContentMenuLinkContent(
        filter: {menu_name: {eq: "navside"}}
        sort: {weight: ASC}
      ) {
        edges {
          node {
            drupal_id
            menu_name
            title
            description
            weight
            drupal_parent_menu_item
            link {
              uri
            }
          }
        }
      }
    }
  `);
  const { setUpTree } = nodeHelper;
  const sidemenuItems = setUpTree(navside);
  return (
    <ContentWrapper>
      <CloseButton onClick={onClose}>
        <CloseIcon />
      </CloseButton>
      <MenuList>
        {sidemenuItems.map(menuItem => {
          return menuItem.title === 'shoppingBasket' ? (
            <li
              onClick={onClose}
              key={queryHelper.getUniqueKey(menuItem)}
              className="snipcart-checkout"
            >
              {menuItem.description}
            </li>
          ) : menuItem.title === 'signIn' ? (
            user ? (
              <Link
                activeClassName="side-menu__link_active"
                key="my-account"
                to="/my-account"
              >
                <li>My Account</li>
              </Link>
            ) : (
              <li
                key={queryHelper.getUniqueKey(menuItem)}
                onClick={ev => domHelper.triggerClick('login-button')}
              >
                {menuItem.description}
              </li>
            )
          ) : (
            <Link
              activeClassName="side-menu__link_active"
              key={queryHelper.getUniqueKey(menuItem)}
              to={queryHelper.getLinkUrl(menuItem.link)}
            >
              <li>{menuItem.description}</li>
            </Link>
          );
        })}
        {user && (
          <li onClick={ev => domHelper.triggerClick('signout-button')}>
            Sign Out
          </li>
        )}
      </MenuList>
      <StayInTouch />
    </ContentWrapper>
  );
};
